/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

(function (window, document) {
    'use strict';
    var input = document.querySelector('[data-hub-szukaj]');
    var wszystkie = document.querySelector('[data-hub-wszystkie]');
    if (!input || !wszystkie) { return; }

    var en = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
    var key = 'pewniaki:analizy-przypiete:v1';
    var limit = 3;
    var cards = Array.prototype.slice.call(wszystkie.querySelectorAll('[data-analiza-card]'));
    var clear = document.querySelector('[data-hub-wyczysc]');
    var state = document.querySelector('[data-hub-stan]');
    var empty = document.querySelector('[data-hub-brak]');
    var pinnedSection = document.querySelector('[data-hub-przypiete]');
    var pinnedList = document.querySelector('[data-hub-przypiete-lista]');

    function normalise(value) {
        var s = String(value || '').toLocaleLowerCase(jst("pages_statystyki_hub_js.f8836a98def4"));
        return typeof s.normalize === 'function' ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
    }
    function readPins() {
        try {
            var value = JSON.parse(window.localStorage.getItem(key) || '[]');
            return Array.isArray(value) ? value.filter(function (x, i, a) {
                return typeof x === 'string' && a.indexOf(x) === i;
            }).slice(0, limit) : [];
        } catch (e) { return []; }
    }
    function savePins(value) {
        try { window.localStorage.setItem(key, JSON.stringify(value.slice(0, limit))); } catch (e) { /* pamięć może być zablokowana */ }
    }
    function cardFor(slug) {
        return cards.filter(function (card) { return card.getAttribute('data-slug') === slug; })[0] || null;
    }
    function renderPins() {
        var pins = readPins().filter(function (slug) { return !!cardFor(slug); });
        if (pinnedList) { while (pinnedList.firstChild) { pinnedList.removeChild(pinnedList.firstChild); } }
        cards.forEach(function (card) {
            var button = card.querySelector('[data-hub-pin]');
            if (!button) { return; }
            var on = pins.indexOf(card.getAttribute('data-slug')) >= 0;
            button.hidden = false;
            button.setAttribute('aria-pressed', on ? 'true' : 'false');
            button.textContent = on ? (jst("pages_statystyki_hub_js.c162ab8faa1c")) : (jst("pages_statystyki_hub_js.57460323a4c7"));
            button.disabled = !on && pins.length >= limit;
        });
        pins.forEach(function (slug) {
            var source = cardFor(slug), link = source && source.querySelector('a');
            if (!source || !link || !pinnedList) { return; }
            var article = document.createElement('article'); article.className = 'karta hub-analiz__kafel';
            var a = document.createElement('a'); a.href = link.href; a.textContent = link.textContent;
            var p = document.createElement('p'); p.className = 'tekst-maly';
            var opis = source.querySelector('p.tekst-maly'); p.textContent = opis ? opis.textContent : '';
            var remove = document.createElement('button'); remove.type = 'button'; remove.className = 'przycisk';
            remove.textContent = jst("pages_statystyki_hub_js.c162ab8faa1c"); remove.setAttribute('data-hub-unpin', slug);
            article.appendChild(a); article.appendChild(p); article.appendChild(remove); pinnedList.appendChild(article);
        });
        if (pinnedSection) { pinnedSection.hidden = pins.length === 0; }
    }
    function togglePin(slug) {
        var pins = readPins(), i = pins.indexOf(slug);
        if (i >= 0) { pins.splice(i, 1); }
        else if (pins.length < limit) { pins.push(slug); }
        savePins(pins); renderPins();
    }
    function filter() {
        var query = normalise(input.value.trim()), visible = 0;
        if (query) { wszystkie.open = true; }
        cards.forEach(function (card) {
            var show = !query || normalise(card.getAttribute('data-search')).indexOf(query) >= 0;
            card.hidden = !show; if (show) { visible++; }
        });
        Array.prototype.forEach.call(wszystkie.querySelectorAll('[data-hub-sekcja]'), function (grid) {
            var section = grid.closest('section');
            if (section) { section.hidden = query && !grid.querySelector('[data-analiza-card]:not([hidden])'); }
        });
        Array.prototype.forEach.call(wszystkie.querySelectorAll('[data-hub-planowane]'), function (x) { x.hidden = !!query; });
        clear.hidden = !query;
        empty.hidden = !query || visible > 0;
        state.textContent = query ? (en ? visible + jst("ui.a99960865083c485") : jst("pages_statystyki_hub_js.literal.c4b8f9058345") + visible) : '';
    }

    if (!window.location.hash) { wszystkie.open = false; }
    input.addEventListener('input', filter);
    clear.addEventListener('click', function () { input.value = ''; filter(); input.focus(); });
    wszystkie.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-hub-pin]') : null;
        if (button) { togglePin(button.closest('[data-analiza-card]').getAttribute('data-slug')); }
    });
    if (pinnedList) {
        pinnedList.addEventListener('click', function (event) {
            var button = event.target.closest ? event.target.closest('[data-hub-unpin]') : null;
            if (button) { togglePin(button.getAttribute('data-hub-unpin')); }
        });
    }
    window.addEventListener('storage', function (event) { if (event.key === key) { renderPins(); } });
    renderPins(); filter();
})(window, document);
